import { numberWithCommas } from '../../helpers';
import { TopPlayerT } from '../../types';
import RocketIcon from '../../assets/svg/utils/rocket/rocket-highlighted.svg';
import LeagueIcon from '../LeagueIcon';
import Energy from '../../assets/svg/utils/energy/energy-ltr.svg';
import ChestRewardIco from '../../assets/images/chests/chest-with-treasure.png';

type LeaderboardUserCardProps = Pick<TopPlayerT, 'username' | 'league'| 'rocket_coins' | 'next_league'> &{
    id?: string
    isUser?: boolean
    first_name?: string
    last_name?: string
}
function LeaderboardUserCard({
  username, first_name: firstName, last_name: lastName, league, rocket_coins: totalCoins, isUser, id, next_league: nextLeague,
}: LeaderboardUserCardProps) {
  const isUserPromotedToNextLeague = league.id !== nextLeague.id;
  return (
    <div
      id={id}
      className={`${isUser ? 'bg-black-2' : `main-gradient-border flex justify-between items-center pl-4 py-2 rounded-10 ${isUserPromotedToNextLeague ? 'bg-leagueCardBgPromoted' : 'bg-leagueCardBg'}`} p-2 rounded-10 flex justify-between`}
    >
      <div className="flex pl-[.125rem]">
        <div className="flex flex-col items-start">
          <div className="text-base font-bold font-Bangers tracking-[0.3px] flex gap-2">
            {username || (`${firstName} ${lastName}`)}
            {isUserPromotedToNextLeague
            && (
            <div className="main-gradient-border league-ready pl-2 font-Bangers text-[10px] rounded-10 flex items-center">
              ready
              <div className="h-[18px] translate-x-[0px] ml-1">
                <LeagueIcon league={nextLeague.name} />
              </div>
            </div>
            )}
          </div>
          <div className="flex items-center text-12 font-normal font-Inrias translate-y-[-3px]">
            {numberWithCommas(totalCoins)}
            <div className="ml-2">
              <img src={RocketIcon} alt="rocket-icon" className="w-[16px]" />
            </div>
          </div>
        </div>
      </div>
      <div className={`text-26 my-auto mx-0 font-normal font-Bangers pr-1 flex
      ${league?.rank === 1 && 'text-transparent bg-clip-text bg-gradient-to-b from-[#FFBB66] to-[#894C00]'}
      ${league?.rank === 2 && 'text-[#A7B7BF]'}
      ${league?.rank === 3 && 'text-[#F27C57]'}
      ${isUser && 'text-gray-300'}
      `}
      >
        #
        {numberWithCommas(league?.rank)}
        {isUserPromotedToNextLeague
            && (
            <div className="ml-2">
              <div className="flex justify-start gap-1">
                {nextLeague?.rewards?.energy
                    && <EnergyReward value={Number(nextLeague?.rewards?.energy || 0)} />}
                {nextLeague?.rewards?.rocket_coins_recovery_per_hour
                    && <RocketCoinsReward value={(Number(nextLeague?.rewards?.rocket_coins_recovery_per_hour || 0))} />}
                {nextLeague?.rewards?.launch_chest
                    && <ChestReward value={nextLeague?.rewards?.launch_chest || 0} />}
                {nextLeague?.rewards?.orbit_chest
                    && <ChestReward value={nextLeague?.rewards?.orbit_chest || 0} />}

              </div>
            </div>
            )}
      </div>
    </div>
  );
}

export default LeaderboardUserCard;

function EnergyReward({ value }: {value: number}) {
  return (
    <div className="relative">
      <img src={Energy} alt="energy-icon" className="w-[36px] translate-y-[2px]" />
      <div className={`absolute text-26 font-normal font-Bangers top-[14px] left-[-8px] px-2
      text-transparent bg-clip-text bg-gradient-to-b from-[#FFE016] to-[#FFFFFF]
      `}
      >
        {value}
      </div>
    </div>
  );
}
function RocketCoinsReward({ value }: {value: number}) {
  return (
    <div className="relative">
      <img src={RocketIcon} alt="rocket-icon" className="h-[36px] translate-y-[4px]" />
      <div className={`absolute text-26 font-normal font-Bangers top-[14px] left-[-8px] px-2
      text-transparent bg-clip-text bg-gradient-to-b from-[#FFE016] to-[#FFFFFF]
      `}
      >
        {value}
      </div>
    </div>
  );
}

function ChestReward({ value }: {value: number}) {
  return (
    <div className="relative">
      <img
        src={ChestRewardIco}
        alt="ChestRewardIco"
        className="absolite top-0 translate-y-[2px] h-[36px]"
      />
      <div className={`absolute text-26 font-normal font-Bangers top-[14px] left-[-10px] px-2
      text-transparent bg-clip-text bg-gradient-to-b from-[#FFE016] to-[#FFFFFF]
      `}
      >
        {value}
      </div>
    </div>
  );
}
